export default {
    methods: {
        displayAsCurrency(value, precision = 2) {
            if (typeof value !== 'number' || !Number.isFinite(value)) return ''
            return new Intl.NumberFormat(this.$i18n.locale, {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: precision,
                maximumFractionDigits: precision,
            }).format(value)
        },
    },
}
